import React from 'react';
import {connect} from "react-redux";
import * as invoiceActions from "../../actions/invoice";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import validation from '../../validation/invoice';
import Validate from 'validate.js';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";

class AdditionalChargeForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            itemID: utilsCommon.notNullNorUndefined(this.props.item.item) ? this.props.item.item.id : null,
            fog: this.props.item.fog,
            schema: {
                type: "object",
                properties: {
                    label: {
                        title: l10n.invoice.label,
                        type: "string",
                    },
                    amount: {
                        title: l10n.invoice.amount,
                        type: "number",
                    },
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                label: {
                    "ui:widget": "textarea"
                }
            },
            fields: {},
            isDirty: false,
            formData: this.props.selectedInvoice
        }
    }

    componentWillReceiveProps (nextProps) {
        this.setState((state) => {return {...state, formData: nextProps.selectedInvoice};});
    }

    componentDidMount() {
        if (utilsCommon.notNullNorUndefined(this.state.itemID)) {
            this.props.dispatch(invoiceActions.get(this.state.itemID, true));
        }
    }

    onSubmit = ({formData}) => {
        formData.amount = utilsCommon.precisionRound(formData.amount);
        let form = Object.assign({}, {...formData});
        form.fog = this.state.fog.id;
        form.archived = this.state.fog.archived;
        form.documentType = this.props.item.type;

        if (utilsCommon.notNullNorUndefined(this.props.selectedInvoice) && (utilsCommon.notNullNorUndefined(this.props.selectedInvoice.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    this.props.dispatch(invoiceActions.edit(form));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(invoiceActions.edit(form));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(invoiceActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData:formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(invoiceActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'additional-charge-form dirty':'additional-charge-form';

        if (this.props.loading || this.props.saving) {
            return (<div><Loader /></div>)
        }

        return (
            <div className={formClassName}>
                <h1>Additional Charge</h1>
                {<CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    fields={this.state.fields}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onError={this.handleError}
                    onSubmit={this.onSubmit}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>}
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.fog.loading || state.invoice.loading,
        saving: state.invoice.saving,
        selectedInvoice: state.invoice.selectedInvoice,


        newlyCreatedElement: state.creation.newlyCreatedInvoice,
    });
})(AdditionalChargeForm);



// WEBPACK FOOTER //
// ./src/components/forms/AdditionalChargeForm.js